<!--===========================
=            GRIDS            =
============================-->
<template>
  <!-- GRID CARDS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Grids</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Playground Grids
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="transparent pa-5 lighten-5">
              <v-row v-for="n in 2" :key="n" :class="n === 1 ? 'mb-6' : ''" no-gutters>
                <v-col v-for="k in n + 1" :key="k">
                  <v-card outlined tile>{{ k }} of {{ n + 1 }}</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Auto sizing columns
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row v-for="n in 2" :key="n" :class="n === 1 ? 'mb-6' : ''" no-gutters>
                <v-col v-for="k in n + 1" :key="k">
                  <v-card outlined tile>{{ k }} of {{ n + 1 }}</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Equal width columns
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row no-gutters>
                <template v-for="n in 4">
                  <v-col :key="n">
                    <v-card outlined tile>Column</v-card>
                  </v-col>
                  <v-responsive v-if="n === 2" :key="`width-${n}`" width="100%"></v-responsive>
                </template>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            One column width
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row class="mb-6" no-gutters>
                <v-col v-for="n in 3" :key="n" :cols="n === 2 ? 6 : undefined">
                  <v-card outlined tile>{{ n }} of 3 {{ n === 2 ? '(wider)' : '' }}</v-card>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col v-for="n in 3" :key="n" :cols="n === 2 ? 5 : undefined">
                  <v-card outlined tile>{{ n }} of 3 {{ n === 2 ? '(wider)' : '' }}</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <!-- GRID  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Variable content width
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row class="mb-6" justify="center" no-gutters>
                <v-col lg="2">
                  <v-card outlined tile>1 of 3</v-card>
                </v-col>
                <v-col md="auto">
                  <v-card outlined tile>Variable width content</v-card>
                </v-col>
                <v-col lg="2">
                  <v-card outlined tile>3 of 3</v-card>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <v-card outlined tile>1 of 3</v-card>
                </v-col>
                <v-col md="auto">
                  <v-card outlined tile>Variable width content</v-card>
                </v-col>
                <v-col lg="2">
                  <v-card outlined tile>3 of 3</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <!-- GRID  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Grow and Shrink
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row class="mb-6" no-gutters>
                <v-col v-for="n in 4" :key="n">
                  <v-card tile outlined>col</v-card>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col v-for="n in 2" :key="n" :cols="n === 1 ? 8 : 4">
                  <v-card tile outlined>col-{{ n === 1 ? 8 : 4 }}</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Row and column breakpoints
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row class="mb-6" no-gutters>
                <v-col v-for="n in 2" :key="n" :lg="cols[n - 1]" :md="6" :sm="cols[n - 1]">
                  <v-card outlined tile>col-{{ cols[n - 1] }}</v-card>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col v-for="n in 3" :key="n" cols="sm">
                  <v-card outlined tile>col</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Unique layouts
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <!-- Stack the columns on mobile by making one full-width and the other half-width -->
              <v-row>
                <v-col cols="12" md="8">
                  <v-card outlined tile>.col-12 .col-md-8</v-card>
                </v-col>
                <v-col cols="6" md="4">
                  <v-card outlined tile>.col-6 .col-md-4</v-card>
                </v-col>
              </v-row>

              <!-- Columns start at 50% wide on mobile and bump up to 33.3% wide on desktop -->
              <v-row>
                <v-col v-for="n in 3" :key="n" cols="6" md="4">
                  <v-card outlined tile>.col-6 .col-md-4</v-card>
                </v-col>
              </v-row>

              <!-- Columns are always 50% wide, on mobile and desktop -->
              <v-row>
                <v-col v-for="n in 2" :key="n" cols="6">
                  <v-card outlined tile>.col-6</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Vertical alignment
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <v-container
                v-for="align in alignments"
                :key="align"
                class="pa-5 transparent lighten-5 mb-6"
              >
                <v-row :align="align" no-gutters style="height: 150px;">
                  <v-col v-for="n in 3" :key="n">
                    <v-card outlined tile>One of three columns</v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-container class="pa-5 transparent lighten-5">
                <v-row no-gutters style="height: 150px;">
                  <v-col v-for="align in alignments" :key="align" :align-self="align">
                    <v-card outlined tile>One of three columns</v-card>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- GRID  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Horizontal alignment
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row v-for="j in justify" :key="j" :justify="j">
                <v-col v-for="k in 2" :key="k" md="4">
                  <v-card outlined tile>One of two columns</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <!-- GRID  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            No gutters
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row no-gutters>
                <v-col cols="12" sm="6" md="8">
                  <v-card outlined tile>.col-12 .col-sm-6 .col-md-8</v-card>
                </v-col>
                <v-col cols="6" md="4">
                  <v-card outlined tile>.col-6 .col-md-4</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Column wrapping
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row no-gutters>
                <v-col cols="9">
                  <v-card outlined tile>.col-9</v-card>
                </v-col>
                <v-col cols="4">
                  <v-card outlined tile>
                    .col-4
                    <br />Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one
                    contiguous unit.
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card outlined tile>
                    .col-6
                    <br />Subsequent columns continue along the new line.
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Order classes
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row no-gutters>
                <v-col>
                  <v-card outlined tile>First, but unordered</v-card>
                </v-col>
                <v-col order="12">
                  <v-card outlined tile>Second, but last</v-card>
                </v-col>
                <v-col order="1">
                  <v-card outlined tile>Third, but first</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Order last / first
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row no-gutters>
                <v-col order="last">
                  <v-card outlined tile>First, but last</v-card>
                </v-col>
                <v-col>
                  <v-card outlined tile>Second, but unordered</v-card>
                </v-col>
                <v-col order="first">
                  <v-card outlined tile>Third, but first</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <!-- GRID  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Offset
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row class="mb-6" no-gutters>
                <v-col md="4">
                  <v-card outlined tile>.col-md-4</v-card>
                </v-col>
                <v-col md="4" offset-md="4">
                  <v-card outlined tile>.col-md-4 .offset-md-4</v-card>
                </v-col>
              </v-row>
              <v-row class="mb-6" no-gutters>
                <v-col md="3" offset-md="3">
                  <v-card outlined tile>.col-md-3 .offset-md-3</v-card>
                </v-col>
                <v-col md="3" offset-md="3">
                  <v-card outlined tile>.col-md-3 .offset-md-3</v-card>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col md="6" offset-md="3">
                  <v-card outlined tile>.col-md-6 .offset-md-3</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <!-- GRID  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Offset breakpoint
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row class="mb-6" no-gutters>
                <v-col sm="5" md="6">
                  <v-card outlined tile>.col-sm-5 .col-md-6</v-card>
                </v-col>
                <v-col sm="5" offset-sm="2" md="6" offset-md="0">
                  <v-card outlined tile>.col-sm-5 .offset-sm-2 .col-md-6 .offset-md-0</v-card>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col sm="6" md="5" lg="6">
                  <v-card outlined tile>.col-sm-6 .col-md-5 .col-lg-6</v-card>
                </v-col>
                <v-col sm="6" md="5" offset-md="2" lg="6" offset-lg="0">
                  <v-card outlined tile>.col-sm-6 .col-md-5 .offset-md-2 .col-lg-6 .offset-lg-0</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Margin utilities
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="ma-5 pa-5">
              <v-container class="pa-5 transparent lighten-5">
                <v-row>
                  <v-col md="4">
                    <v-card outlined tile>.col-md-4</v-card>
                  </v-col>
                  <v-col md="4" class="ml-auto">
                    <v-card outlined tile>.col-md-4 .ml-auto</v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="3" class="ml-md-auto">
                    <v-card outlined tile>.col-md-3 .ml-md-auto</v-card>
                  </v-col>
                  <v-col md="3" class="ml-md-auto">
                    <v-card outlined tile>.col-md-3 .ml-md-auto</v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="auto" class="mr-auto">
                    <v-card outlined tile>.col-auto .mr-auto</v-card>
                  </v-col>
                  <v-col cols="auto">
                    <v-card outlined tile>.col-auto</v-card>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Nested grid
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row>
                <v-col sm="9">
                  <v-card outlined tile>Level 1: .col-sm-9</v-card>
                  <v-row no-gutters>
                    <v-col cols="8" sm="6">
                      <v-card outlined style="background-color: lightpa-5 transparent;" tile>
                        Level 2: .col-8
                        .col-sm-6
                      </v-card>
                    </v-col>
                    <v-col cols="4" sm="6">
                      <v-card outlined style="background-color: lightpa-5 transparent;" tile>
                        Level 3: .col-4
                        .col-sm-6
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Spacers
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-5 transparent lighten-5">
              <v-row>
                <v-col>
                  <v-card outlined tile>.col</v-card>
                </v-col>

                <v-spacer></v-spacer>

                <v-col>
                  <v-card outlined tile>.col</v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="auto" lg="3">
                  <v-card outlined tile>.col-auto</v-card>
                </v-col>

                <v-spacer></v-spacer>

                <v-col>
                  <v-card outlined tile>.col</v-card>
                </v-col>

                <v-spacer></v-spacer>

                <v-col md="5">
                  <v-card cols="auto" outlined tile>.col-md-5</v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data() {
    return {
      alignments: ["start", "center", "end"],
      alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
      alignment: "center",
      dense: false,
      justifyAvailable: [
        "start",
        "center",
        "end",
        "space-around",
        "space-between"
      ],

      justify: ["start", "center", "end", "space-around", "space-between"]
    };
  },
  computed: {
    cols() {
      const { lg, sm } = this.$vuetify.breakpoint;
      return lg ? [3, 9] : sm ? [9, 3] : [6, 6];
    }
  }
};
</script>


<!--====  End of GRIDS  ====-->
